<template>
  <div>
    <FormField
      :context="{ formType: 'filter' }"
      v-model:value="value"
      :dataKey="col.ColumnNamePc"
      :affectFields="col.SetFieldsAfterSelect"
      :showAllOptionInSelect="col.ShowAllOptionInSelect"
      :showStar="false"
      :inputType="
        getControlTypeMapping(col.FilterControlType ?? col.ControlType)
      "
      :label="col.ColumnLabel"
      @onEnterPressed="
        () => {
          emits('filter', value);
        }
      "
      :misc="{
        fetchOptions: true,
        displayKey: col.DisplayColumnName,
        valueKey: col.ValueColumnName,
        endpoint: col.EndpointRoute,
        filter: cascadeFilter(
          col.CascadeFrom,
          col.ApplyCascadeOnLookupProperty
        ),
        tokenData: tokenData,
      }"
      :colSpan="{
        sm: col.ColSpanSm,
        md: col.ColSpanMd,
        lg: col.ColSpanLg,
        xl: col.ColSpanXl,
        xxl: col.ColSpanXxl,
      }"
      :id="col.ColumnNamePc"
      :placeholder="col.Placeholder ? col.Placeholder : col.ColumnLabel"
      :name="col.ColumnNamePc"
      :tableId="props.meta.data.Table.Id"
    />
  </div>
</template>

<script setup lang="ts">
import type { InputType } from "~/scad-shared/types/generic";
import type { IMetaColumn, IMetaComputed } from "~/scad-shared/types/scad";

const props = defineProps<{
  col: IMetaColumn;
  filterData: any;
  meta: IMetaComputed;
}>();

const emits = defineEmits<{
  filter: [value: any];
}>();

const tokenData = computed(() => ({}));

const value = defineModel<any>("value");

const cascadeFilter = computed(() => {
  return (cascadeFrom: string, applyCascadeOnLookupProperty?: string) => {
    if (!applyCascadeOnLookupProperty) {
      applyCascadeOnLookupProperty = undefined;
    }
    const filter: { [key: string]: any } = {};

    if (cascadeFrom) {
      let selectedValue = cascadeFrom
        .trim()
        .split(".")
        .reduce((a, b) => a[b], props.filterData);

      if (selectedValue == undefined || selectedValue == null) {
        //no selection has been made in the parent control yet
        //so apply a filter value of zero on the cascade property, the idea being that this should result in no records being returned
        //console.log('cascading on 0', cascadeFrom);
        filter[applyCascadeOnLookupProperty ?? cascadeFrom] = 0;
        // @ts-ignore
      } else if (selectedValue === 0) {
        //the user has selected an All option.
        // so no need to apply a filter at all
        //console.log('cascading on all', cascadeFrom);
      } else {
        //the user has selected an option in the cascade parent
        //console.log('cascading on ', cascadeFrom,record.value[cascadeFrom]);
        filter[applyCascadeOnLookupProperty ?? cascadeFrom] =
          props.filterData[cascadeFrom];
      }
    }
    return filter;
  };
});

function getControlTypeMapping(ControlType: string): InputType | undefined {
  // @ts-ignore
  return ControlTypeToGenericInputType(ControlType);
}
</script>

<style scoped></style>
